import React from 'react'
import './link-pop-up.css'


const LinkPopUp = (props) => {
    React.useEffect(() => {
        let position = calculateSidetoSide(props.start)
        let depth = calculateUpDown(props.top)
        document.getElementById("style-selector").style.marginLeft = `${position}px`
        document.getElementById("style-selector-wrapper").style.top = `${depth}px`
    }, [])

    const calculateSidetoSide = (start) => {
        return start - 100
    }
    const calculateUpDown = (start) => {
        return start - 78
    }
    return(
        <div className="style-selector-wrapper" id="style-selector-wrapper">
            <div className="style-popup-whole-wrapper">
                <div className="style-selector" id="style-selector">
                    <input className="link-input-field" id="link-input-field" onKeyUp={(e) => props.addTheLink(e)} placeholder="Paste or type a link..." />
                    <div className="style-selector-square"></div>
                </div>
            </div>
        </div>
    )
}
export default LinkPopUp